export const Colors = {
    HeaderBackground: "#A5553C",
    HeaderText: "#FCBD92",
    Black: "#1A1A1A",
    White: "#FCFCFC",
    GreyButtonsTable: "#E9E9E9",
    LightGreen: "#A4AFA3",
}